let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9cbXp")).then(() => parcelRequire('84LIP'));